import {useState, useCallback} from 'react';
import makeRequest from 'makeRequest';
import {debounce} from 'lodash';
import {getToken} from 'helpers/getToken';

const apis = {
    address: 'location_autocomplete',
    location: 'location_autocomplete',
};

const defaultType = 'location_autocomplete';

const useAPIOptions = type => {
    const [options, setOptions] = useState([]);

    const fetchOptionsFromApi = useCallback(async str => {
        const path = apis[type] || defaultType;
        const authToken = getToken();
        try {
            const res = await makeRequest({path, data: {authToken, query: str}});
            setOptions(res);
        } catch (error) {
            console.log(error);
        }
    }, []);

    const debouncedFetch = useCallback(debounce(fetchOptionsFromApi, 300), []);

    return [options, setOptions, debouncedFetch];
};

export default useAPIOptions;
